import { lazy } from "react";

export const MySBTsPage = lazy(() =>
  import("./ui/my-sbts").then((module) => ({
    default: module.MySBTs,
  }))
);
